import { Trans } from '@lingui/react'
import { node, string } from 'prop-types'

const BonusBadge = ({ children, labelKey }) => {
  if (!children) {
    return null
  }

  return (
    <div className="a-Badge u-background-color--rxgreen">
      <div className="a-Badge__inner u-transform-center u-color--white u-text-align--center">
        <span className="a-Badge__label u-display--block">{children}</span>
        <span className="a-Badge__label a-Badge__label--smaller u-display--block">
          <Trans id={labelKey} />
        </span>
      </div>
    </div>
  )
}

BonusBadge.propTypes = {
  children: node.isRequired,
  labelKey: string,
}

BonusBadge.defaultProps = {
  labelKey: /*i18n*/ 'general.label.bonus',
}

export default BonusBadge
